import getLuggageCodeWeight from './getLuggageCodeWeight'

export default (luggageCode = '') => {
  const luggageWeight = getLuggageCodeWeight(luggageCode)

  return luggageWeight ? `${luggageWeight} kg` : ''
}
